<template>
    <div class="container">
        <PatientsListingFilters 
            :filters="params" 
            :graduate-unread-messages-count="graduateUnreadMessagesCount" 
            :order-options="orderOptions"
            @change="onFilters" 
        />

        <div class="matrix-panel">
            <div class="table-layout table-patient table-maintenance table-therapist">
                <TableHeader v-if="patients.length !== 0" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :params="params"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :patient="patient" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />
                </PatientsListingTableBody>
            </div>
        </div>
    </div>
</template>

<script>
import PatientRow from '@components/Coaches/PatientsMatrix/Graduate/PatientRow'
import TableHeader from '@components/Coaches/PatientsMatrix/Graduate/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    props: {
        graduateUnreadMessagesCount: {
            type: Number,
            required: false
        },
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
    },
    mounted() {
        $(function() {
            $('.item-graduate').addClass('active')
        })
    }
}
</script>
